import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaShoppingBag } from "react-icons/fa";
import { GiShuttlecock, GiRollerSkate, GiCricketBat } from "react-icons/gi";

const FeatureSection = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await fetch("https://code.gurusport.in/api/site-banner");
        const data = await res.json();

        if (data?.top_banner?.data) {
          setBanners(data.top_banner.data);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanners();
  }, []);

  const categories = [
    {
      title: "Badminton",
      subtitle: "Rackets & Shuttlecocks",
      icon: <GiShuttlecock />,
    },
    {
      title: "Skates and Rollers",
      subtitle: "Skates & Protective Gear",
      icon: <GiRollerSkate />,
    },
    {
      title: "Cricket",
      subtitle: "Bats, Balls & Pads",
      icon: <GiCricketBat />,
    },
    {
      title: "Accessories",
      subtitle: "Training Essentials",
      icon: <FaShoppingBag />,
    },
  ];

  const getImage = (banner) =>
    banner?.banner_image
      ? `https://code.gurusport.in/storage/${banner.banner_image}`
      : "";

  const getMatchingBanner = (title) =>
    banners.find(
      (b) =>
        (b?.banner_placement || b?.name || "").trim().toLowerCase() ===
        title.trim().toLowerCase()
    );

  const CardWrapper = ({ banner, children }) => {
    if (!banner?.target_url) return children;

    if (banner.target_url.startsWith("http")) {
      return (
        <a
          href={banner.target_url}
          target="_blank"
          rel="noopener noreferrer"
          className="block h-full"
        >
          {children}
        </a>
      );
    }

    return (
      <Link to={banner.target_url} className="block h-full">
        {children}
      </Link>
    );
  };

  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Heading */}
        <div className="mb-12">
          <span className="text-red-600 uppercase tracking-[4px] text-xs font-semibold">
            Explore Collection
          </span>

          <h2 className="text-black text-4xl md:text-5xl font-black uppercase mt-4">
            Shop By Category
          </h2>

          <div className="w-20 h-[2px] bg-red-600 mt-5" />
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {categories.map((item, index) => {
            const matchedBanner = getMatchingBanner(item.title);
            const image = getImage(matchedBanner);

            return (
              <CardWrapper key={index} banner={matchedBanner}>
                <div
                  className="
                    group
                    relative
                    flex
                    flex-col
                    h-full
                    overflow-hidden
                    rounded-2xl
                    bg-white
                    border
                    border-gray-200
                    shadow-[0_1px_2px_rgba(0,0,0,0.04)]
                    transition-all
                    duration-300
                    hover:-translate-y-1
                    hover:shadow-[0_12px_28px_rgba(0,0,0,0.10)]
                    hover:border-red-600/40
                    cursor-pointer
                  "
                >
                  {/* Icon badge */}
                  <div
                    className="
                      absolute
                      top-4
                      left-4
                      z-20
                      w-11
                      h-11
                      rounded-xl
                      bg-red-600
                      text-white
                      text-xl
                      flex
                      items-center
                      justify-center
                      shadow-md
                      shadow-red-600/25
                      transition-transform
                      duration-300
                      group-hover:scale-105
                    "
                  >
                    {item.icon}
                  </div>

                  {/* Image area */}
                  <div className="relative h-[230px] bg-gradient-to-br from-gray-50 via-white to-gray-200 overflow-hidden">
                    {image ? (
                      <img
                        src={image}
                        alt={item.title}
                        className="
                          absolute
                          inset-0
                          w-full
                          h-full
                          object-cover
                          transition-transform
                          duration-700
                          group-hover:scale-105
                        "
                      />
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center text-gray-300 text-6xl">
                        {item.icon}
                      </div>
                    )}

                    {/* Soft fade into the footer */}
                    <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent" />
                  </div>

                  {/* Footer text */}
                  <div className="relative z-10 bg-white px-5 pb-6 pt-1">
                    <h3 className="text-gray-900 text-lg font-extrabold uppercase tracking-wide">
                      {item.title}
                    </h3>

                    <p className="text-gray-500 mt-1 text-sm">
                      {item.subtitle}
                    </p>

                    <div
                      className="
                        mt-3
                        w-0
                        h-[2px]
                        bg-red-600
                        rounded-full
                        transition-all
                        duration-500
                        group-hover:w-14
                      "
                    />
                  </div>
                </div>
              </CardWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;